import { render } from "./TableS1.vue?vue&type=template&id=2acf9df8&scoped=true"
import script from "./TableS1.vue?vue&type=script&lang=js"
export * from "./TableS1.vue?vue&type=script&lang=js"

import "./TableS1.vue?vue&type=style&index=0&id=2acf9df8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2acf9df8"

export default script